module.exports = __webpack_public_path__ + "static/media/refined-searches.151fda14.png";